/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./multi-selector.vue?vue&type=template&id=d2b12df4&"
import script from "./multi-selector.vue?vue&type=script&lang=js&"
export * from "./multi-selector.vue?vue&type=script&lang=js&"
import style0 from "./multi-selector.vue?vue&type=style&index=0&id=d2b12df4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports